// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/img/banner1.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;1,300&family=Poppins:wght@300;400;500&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Homepage header and hero: single source of truth */
.home-navbar {
  width: 100%;
  margin: 0;
  position: relative;
  overflow: hidden;
  background: #05090d;
}

.home-navbar .home-nav-container,
.home-navbar .hero-content-container {
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
  padding-inline: 64px;
  box-sizing: border-box;
}

.home-navbar .home-nav-container {
  position: relative;
  z-index: 2;
}

.home-navbar .home-nav-menu {
  width: 100%;
  height: 78px;
  min-height: 78px;
  padding: 0;
  flex-shrink: 0;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  column-gap: 0;
  align-items: center;
  position: relative;
  z-index: 2;
  border-bottom: 1px solid rgba(17, 17, 17, .08);
  background: #f7f5f0;
  box-shadow: 0 0 0 100vmax #f7f5f0;
  clip-path: inset(0 -100vmax);
  box-sizing: border-box;
}

.home-navbar .home-nav-logo {
  position: static;
  width: 98px;
  height: auto;
  justify-self: start;
  flex: 0 0 auto;
  object-fit: contain;
  cursor: pointer;
  filter: brightness(0);
  transition: opacity .25s ease;
}

.home-navbar .home-nav-logo:hover { opacity: .86; }

.home-navbar .home-nav-center {
  width: auto;
  margin: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  justify-self: center;
  flex-wrap: nowrap;
  gap: 56px;
  white-space: nowrap;
}

.home-navbar .home-nav-actions {
  margin: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  justify-self: end;
  gap: 46px;
  white-space: nowrap;
}

.home-navbar .home-nav-center > :not(style) ~ :not(style),
.home-navbar .home-nav-actions > :not(style) ~ :not(style) { margin: 0; }

.home-navbar .home-nav-link a {
  color: #111111;
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: .12em;
  text-decoration: none;
  text-transform: uppercase;
  transition: color .25s ease;
}

.home-navbar .home-nav-link a:hover { color: #111111; }
.home-navbar .home-nav-link::after {
  content: "";
  display: block;
  margin-top: 4px;
  border-bottom: 1px solid rgba(184, 138, 68, .5);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform .25s ease;
}
.home-navbar .home-nav-link:hover::after { transform: scaleX(1); }
.home-navbar .home-nav-link-active a { color: #111111; }
.home-navbar .home-nav-link-active::after { transform: scaleX(1); }

.home-navbar .home-nav-menu svg {
  color: #111111;
  filter: none;
  transition: color .25s ease;
}

.home-navbar #basic-button img { filter: brightness(0); }

.home-navbar .hero-shell {
  position: relative;
  width: min(100%, 1500px);
  aspect-ratio: 1440 / 671;
  margin-inline: auto;
  overflow: hidden;
  background: #05090d;
}

.home-navbar .hero-content-container {
  position: relative;
  z-index: 1;
  height: 100%;
}

.home-navbar .hero-layout {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: minmax(0, 560px) minmax(0, 1fr);
  align-items: center;
  box-sizing: border-box;
}

.home-navbar .hero-copy {
  width: 100%;
  max-width: 560px;
  padding-left: 0;
  align-items: flex-start;
  box-sizing: border-box;
  position: relative;
  z-index: 2;
}

.home-navbar .hero-copy::before {
  content: "";
  display: block;
  width: 48px;
  height: 1px;
  margin-bottom: 18px;
  background: #b88a44;
}

.home-navbar .hero-headline.MuiTypography-root {
  max-width: 560px;
  margin: 0;
  color: #f4f1ea;
  font-family: "Cormorant Garamond", serif;
  font-size: 58px;
  font-weight: 300;
  line-height: .98;
  letter-spacing: .01em;
  text-transform: uppercase;
}

.home-navbar .hero-subtitle.MuiTypography-root {
  margin: 16px 0 0;
  color: #b88a44;
  font-family: "Cormorant Garamond", serif;
  font-size: 20px;
  font-style: italic;
  font-weight: 300;
  line-height: 1.2;
  letter-spacing: .01em;
}

.home-navbar .hero-service.MuiTypography-root {
  max-width: 500px;
  margin: 12px 0 0;
  color: rgba(95, 107, 115, .9);
  font-family: "Poppins", sans-serif;
  font-size: 11px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: .11em;
  text-transform: uppercase;
}

.home-navbar .hero-actions {
  width: auto;
  margin-top: 28px;
  align-self: flex-start;
  display: flex;
  flex: 0 0 auto;
  justify-content: flex-start;
}

.home-navbar .signup-button.MuiButton-root {
  width: 158px;
  min-width: 0;
  height: 44px;
  padding: 0 18px;
  border: 1px solid #b88a44;
  border-radius: 3px;
  background: #b88a44;
  color: #10202b;
  box-shadow: none;
  font-family: "Poppins", sans-serif;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  letter-spacing: .12em;
  text-transform: uppercase;
  transition: background-color .225s ease, border-color .225s ease, transform .225s ease;
}

.home-navbar .signup-button.MuiButton-root:hover {
  border-color: #111111;
  background: #111111;
  color: #f7f5f0;
  box-shadow: none;
  transform: translateY(-1px);
}

.home-navbar .hero-media {
  position: absolute;
  inset: 0;
  z-index: 0;
  display: flex;
  justify-content: center;
  overflow: hidden;
}

.home-navbar .hero-watch {
  display: block;
  width: 100%;
  height: 100%;
  max-width: 1500px;
  object-fit: cover;
  object-position: center right;
  border: 0;
  margin: 0;
}
.home-navbar .home-nav-login.MuiButton-root {
  width: 128px;
  min-width: 128px;
  height: 42px;
  padding: 0 16px;
  border: 1px solid #111111;
  border-radius: 4px;
  background: transparent;
  color: #111111;
  box-shadow: none;
  font-family: "Poppins", sans-serif;
  font-size: 11px;
  font-weight: 500;
  line-height: 1;
  letter-spacing: .12em;
  text-transform: uppercase;
  transition: background-color .225s ease, border-color .225s ease, color .225s ease;
}

.home-navbar .home-nav-login.MuiButton-root:hover {
  border-color: #111111;
  background: #111111;
  color: #f7f5f0;
  box-shadow: none;
}

.home-navbar .home-nav-avatar {
  width: 36px;
  height: 36px;
  border: 1px solid rgba(184, 138, 68, .36) !important;
  border-radius: 50%;
  object-fit: cover;
  cursor: pointer;
}

@media (max-width: 1100px) {
  .home-navbar .home-nav-container,
  .home-navbar .hero-content-container { padding-inline: 32px; }

  .home-navbar .hero-watch { max-width: none; }
  .home-navbar .home-nav-menu {
    grid-template-columns: 1fr auto 1fr;
    column-gap: 0;
  }
  .home-navbar .home-nav-center { gap: 40px; }
  .home-navbar .home-nav-actions { gap: 32px; }
  .home-navbar .home-nav-link a { font-size: 14px; }
  .home-navbar .hero-copy { max-width: 480px; }
  .home-navbar .hero-headline.MuiTypography-root { font-size: clamp(48px, 5.5vw, 60px); }
  .home-navbar .hero-subtitle.MuiTypography-root { font-size: 19px; }
  .home-navbar .hero-watch { object-position: 68% center; }
}

@media (max-width: 760px) {
  .home-navbar .home-nav-container,
  .home-navbar .hero-content-container { padding-inline: 16px; }
  .home-navbar .home-nav-menu {
    height: 64px;
    min-height: 64px;
    grid-template-columns: auto 1fr auto;
  }
  .home-navbar .home-nav-logo { width: 82px; }
  .home-navbar .home-nav-center { gap: 12px; }
  .home-navbar .home-nav-actions { gap: 12px; }
  .home-navbar .home-nav-link { display: none; }

  .home-navbar .hero-copy {
    max-width: 360px;
    padding-left: 0;
  }
  .home-navbar .hero-headline.MuiTypography-root { font-size: clamp(40px, 11vw, 52px); }

  .home-navbar .hero-watch { width: 100%; object-position: 64% center; }
  .home-navbar .signup-button.MuiButton-root { width: 158px; height: 44px; }
}
/* OTHER NAVBAR */
.other-navbar {
  width: 100%;
  height: 300px;
  display: flex;
  flex-direction: column;
  background: linear-gradient(rgba(14,17,22,0.93), rgba(14,17,22,0.99)),
              url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
}

.other-navbar .menu {
  width: 100%;
  height: 64px;
  padding: 0 64px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  border-bottom: 1px solid rgba(227, 192, 141, 0.07);
  
}

.other-navbar .links {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 48px;
  margin-right: 40px;
}

.other-navbar .hover-line a {
  color: rgba(255,255,255,0.6) !important;
  font-size: 10px !important;
  text-transform: uppercase !important;
  letter-spacing: 3px !important;
  font-family: "Poppins", sans-serif !important;
  font-weight: 400 !important;
  text-decoration: none !important;
  transition: color 0.3s ease;
}

.other-navbar .hover-line a:hover { color: #e3c08d !important; }

.other-navbar .hover-line::after {
  display: block; content: "";
  border-bottom: 1px solid rgba(227,192,141,0.6);
  transform: scaleX(0);
  transition: transform 280ms ease-in-out;
  margin-top: 4px;
}

.other-navbar .hover-line:hover::after { transform: scaleX(1); }

.other-navbar .login-button {
  background: transparent !important;
  color: #e3c08d !important;
  border: 1px solid rgba(227,192,141,0.55) !important;
  border-radius: 0 !important;
  padding: 9px 26px !important;
  font-family: "Poppins", sans-serif !important;
  font-size: 9px !important;
  font-weight: 400 !important;
  text-transform: uppercase !important;
  letter-spacing: 3px !important;
  cursor: pointer;
  transition: all 0.3s ease !important;
}

.other-navbar .login-button:hover {
  background: #e3c08d !important;
  color: #0e1116 !important;
}
 
.other-navbar.products-navbar {
  width: 100%;
  height: 78px;
  min-height: 78px;
  background: #f7f5f0;
  border-bottom: 1px solid rgba(17, 17, 17, .08);
}

.other-navbar.products-navbar .navbar-container {
  width: 100%;
  max-width: 1500px;
  height: 100%;
  max-width: 1500px;
  margin: 0 auto;
  padding: 0 64px;
  box-sizing: border-box;
}

.other-navbar.products-navbar .menu {
  width: 100%;
  height: 78px;
  min-height: 78px;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  column-gap: 0;
  align-items: center;
  border-bottom: 0;
  box-sizing: border-box;
}

.other-navbar.products-navbar .other-nav-brand {
  display: flex;
  align-items: center;
  justify-self: start;
}

.other-navbar.products-navbar .brand-logo {
  display: block;
  width: 98px;
  height: auto;
  object-fit: contain;
  filter: brightness(0);
}

.other-navbar.products-navbar .other-nav-center {
  width: auto;
  margin: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  justify-self: center;
  flex-wrap: nowrap;
  gap: 56px;
  white-space: nowrap;
}

.other-navbar.products-navbar .other-nav-actions {
  margin: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  justify-self: end;
  gap: 46px;
  white-space: nowrap;
}

.other-navbar.products-navbar .other-nav-center > :not(style) ~ :not(style),
.other-navbar.products-navbar .other-nav-actions > :not(style) ~ :not(style) {
  margin: 0;
}

.other-navbar.products-navbar #basic-button img { filter: brightness(0); }

.other-navbar.products-navbar .hover-line a {
  color: #111111 !important;
  font-family: "Poppins", sans-serif !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 1.5;
  letter-spacing: .12em !important;
}

.other-navbar.products-navbar .hover-line a.underline {
  color: #111111 !important;
  border-bottom: 1px solid #b88a44;
}

.other-navbar.products-navbar .login-button {
  width: 128px;
  min-width: 128px;
  height: 42px;
  padding: 0 16px !important;
  border: 1px solid #111111 !important;
  border-radius: 4px !important;
  background: transparent !important;
  color: #111111 !important;
  box-shadow: none;
  font-family: "Poppins", sans-serif !important;
  font-size: 11px !important;
  font-weight: 500 !important;
  line-height: 1;
  letter-spacing: .12em !important;
}

.other-navbar.products-navbar .login-button:hover {
  border-color: #111111 !important;
  background: #111111 !important;
  color: #f7f5f0 !important;
  box-shadow: none;
}

.other-navbar.products-navbar .user-avatar {
  width: 36px;
  height: 36px;
  border: 1px solid rgba(184, 138, 68, .36) !important;
  border-radius: 50%;
  object-fit: cover;
  cursor: pointer;
}

@media (max-width: 1100px) {
  .other-navbar.products-navbar .navbar-container { padding: 0 32px; }
  .other-navbar.products-navbar .other-nav-center { gap: 40px; }
  .other-navbar.products-navbar .other-nav-actions { gap: 32px; }
}

@media (max-width: 760px) {
  .other-navbar.products-navbar .navbar-container { padding: 0 16px; }

  .other-navbar.products-navbar .menu {
    grid-template-columns: 1fr auto;
  }

  .other-navbar.products-navbar .brand-logo { width: 82px; }
  .other-navbar.products-navbar .other-nav-center { display: none; }
  .other-navbar.products-navbar .other-nav-actions { gap: 12px; }
}/* BASKET ^5.8.4*/

.basket-frame {
  position: relative;
  padding: 10px 4px 0px 4px;
  width: 450px;
  height: auto;
  display: flex;
  flex-direction: column;
  background: #f8f8ff;
  border-radius: 16px;
}

.basket-frame .all-check-box {
  padding: 0px 6px;
  width: 100%;
  height: 34px;
  display: flex;
  flex-direction: row;
  align-items: center;
  background: #d7b586;
  border-width: 1px 0px;
  border-style: solid;
  border-color: #343434;
}

.basket-frame .basket-info-box {
  position: relative;
  margin-top: 6px;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.basket-info-box .product-img {
  width: 60px;
  height: 60px;
  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25));
  border-radius: 29px;
}

.basket-info-box .product-name {
  margin-left: 11px;
  width: 185px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  color: #000000;
}

.basket-info-box .product-price {
  width: 80px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 22px;
  color: #ae0000;
}

.basket-info-box
  .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {
  padding: 6.5px 14px;
}

.basket-info-box .css-ece9u5 {
  min-width: 72px;
}

.basket-frame .cancel-btn {
  position: absolute;
  top: 33%;
  right: 2%;
  cursor: pointer;
}

.basket-frame .basket-order {
  margin-top: 10px;
  width: 100%;
  height: 64px;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  border-top: 1px solid rgba(0, 0, 0, 0.5);
}

.basket-order .price {
  width: 200px;
  display: flex;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  color: #000000;
}

.basket-frame .orders-wrapper {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  max-width: 1500px;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
}

.basket-frame .orders-wrapper::-webkit-scrollbar {
  width: 10px;
}

.basket-frame .orders-wrapper::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 5px;
}

.basket-frame .orders-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.basket-frame .orders-main-wrapper {
  position: relative;
  overflow: hidden;
  margin-top: 10px;
  width: 100%;
  height: 260px;
  display: flex;
  flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./src/css/navbar.css"],"names":[],"mappings":"AAEA,qDAAqD;AACrD;EACE,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,aAAa;EACb,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,8CAA8C;EAC9C,mBAAmB;EACnB,iCAAiC;EACjC,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA,oCAAoC,YAAY,EAAE;;AAElD;EACE,WAAW;EACX,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,SAAS;EACT,mBAAmB;AACrB;;AAEA;6DAC6D,SAAS,EAAE;;AAExE;EACE,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,sCAAsC,cAAc,EAAE;AACtD;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,+CAA+C;EAC/C,oBAAoB;EACpB,sBAAsB;EACtB,+BAA+B;AACjC;AACA,2CAA2C,oBAAoB,EAAE;AACjE,uCAAuC,cAAc,EAAE;AACvD,4CAA4C,oBAAoB,EAAE;;AAElE;EACE,cAAc;EACd,YAAY;EACZ,2BAA2B;AAC7B;;AAEA,iCAAiC,qBAAqB,EAAE;;AAExD;EACE,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,aAAa;EACb,sDAAsD;EACtD,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,sFAAsF;AACxF;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,6BAA6B;EAC7B,SAAS;EACT,SAAS;AACX;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,kFAAkF;AACpF;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE;yCACuC,oBAAoB,EAAE;;EAE7D,2BAA2B,eAAe,EAAE;EAC5C;IACE,mCAAmC;IACnC,aAAa;EACf;EACA,gCAAgC,SAAS,EAAE;EAC3C,iCAAiC,SAAS,EAAE;EAC5C,gCAAgC,eAAe,EAAE;EACjD,0BAA0B,gBAAgB,EAAE;EAC5C,iDAAiD,mCAAmC,EAAE;EACtF,iDAAiD,eAAe,EAAE;EAClE,2BAA2B,2BAA2B,EAAE;AAC1D;;AAEA;EACE;yCACuC,oBAAoB,EAAE;EAC7D;IACE,YAAY;IACZ,gBAAgB;IAChB,oCAAoC;EACtC;EACA,8BAA8B,WAAW,EAAE;EAC3C,gCAAgC,SAAS,EAAE;EAC3C,iCAAiC,SAAS,EAAE;EAC5C,8BAA8B,aAAa,EAAE;;EAE7C;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA,iDAAiD,kCAAkC,EAAE;;EAErF,2BAA2B,WAAW,EAAE,2BAA2B,EAAE;EACrE,6CAA6C,YAAY,EAAE,YAAY,EAAE;AAC3E;AACA,iBAAiB;AACjB;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB;qDACmC;EACnC,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kDAAkD;;AAEpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;EAC1B,oCAAoC;EACpC,8BAA8B;EAC9B,6CAA6C;EAC7C,2BAA2B;EAC3B,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA,oCAAoC,yBAAyB,EAAE;;AAE/D;EACE,cAAc,EAAE,WAAW;EAC3B,8CAA8C;EAC9C,oBAAoB;EACpB,uCAAuC;EACvC,eAAe;AACjB;;AAEA,yCAAyC,oBAAoB,EAAE;;AAE/D;EACE,kCAAkC;EAClC,yBAAyB;EACzB,mDAAmD;EACnD,2BAA2B;EAC3B,4BAA4B;EAC5B,6CAA6C;EAC7C,yBAAyB;EACzB,2BAA2B;EAC3B,oCAAoC;EACpC,8BAA8B;EAC9B,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;AACX;;AAEA,kDAAkD,qBAAqB,EAAE;;AAEzE;EACE,yBAAyB;EACzB,6CAA6C;EAC7C,0BAA0B;EAC1B,2BAA2B;EAC3B,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,oCAAoC;EACpC,6BAA6B;EAC7B,kCAAkC;EAClC,yBAAyB;EACzB,gBAAgB;EAChB,6CAA6C;EAC7C,0BAA0B;EAC1B,2BAA2B;EAC3B,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kDAAkD,eAAe,EAAE;EACnE,kDAAkD,SAAS,EAAE;EAC7D,mDAAmD,SAAS,EAAE;AAChE;;AAEA;EACE,kDAAkD,eAAe,EAAE;;EAEnE;IACE,+BAA+B;EACjC;;EAEA,4CAA4C,WAAW,EAAE;EACzD,kDAAkD,aAAa,EAAE;EACjE,mDAAmD,SAAS,EAAE;AAChE,CAAC,iBAAiB;;AAElB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oDAAoD;EACpD,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;1,300&family=Poppins:wght@300;400;500&display=swap');\n\n/* Homepage header and hero: single source of truth */\n.home-navbar {\n  width: 100%;\n  margin: 0;\n  position: relative;\n  overflow: hidden;\n  background: #05090d;\n}\n\n.home-navbar .home-nav-container,\n.home-navbar .hero-content-container {\n  width: 100%;\n  max-width: 1500px;\n  margin: 0 auto;\n  padding-inline: 64px;\n  box-sizing: border-box;\n}\n\n.home-navbar .home-nav-container {\n  position: relative;\n  z-index: 2;\n}\n\n.home-navbar .home-nav-menu {\n  width: 100%;\n  height: 78px;\n  min-height: 78px;\n  padding: 0;\n  flex-shrink: 0;\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  column-gap: 0;\n  align-items: center;\n  position: relative;\n  z-index: 2;\n  border-bottom: 1px solid rgba(17, 17, 17, .08);\n  background: #f7f5f0;\n  box-shadow: 0 0 0 100vmax #f7f5f0;\n  clip-path: inset(0 -100vmax);\n  box-sizing: border-box;\n}\n\n.home-navbar .home-nav-logo {\n  position: static;\n  width: 98px;\n  height: auto;\n  justify-self: start;\n  flex: 0 0 auto;\n  object-fit: contain;\n  cursor: pointer;\n  filter: brightness(0);\n  transition: opacity .25s ease;\n}\n\n.home-navbar .home-nav-logo:hover { opacity: .86; }\n\n.home-navbar .home-nav-center {\n  width: auto;\n  margin: 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  justify-self: center;\n  flex-wrap: nowrap;\n  gap: 56px;\n  white-space: nowrap;\n}\n\n.home-navbar .home-nav-actions {\n  margin: 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  justify-self: end;\n  gap: 46px;\n  white-space: nowrap;\n}\n\n.home-navbar .home-nav-center > :not(style) ~ :not(style),\n.home-navbar .home-nav-actions > :not(style) ~ :not(style) { margin: 0; }\n\n.home-navbar .home-nav-link a {\n  color: #111111;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: .12em;\n  text-decoration: none;\n  text-transform: uppercase;\n  transition: color .25s ease;\n}\n\n.home-navbar .home-nav-link a:hover { color: #111111; }\n.home-navbar .home-nav-link::after {\n  content: \"\";\n  display: block;\n  margin-top: 4px;\n  border-bottom: 1px solid rgba(184, 138, 68, .5);\n  transform: scaleX(0);\n  transform-origin: left;\n  transition: transform .25s ease;\n}\n.home-navbar .home-nav-link:hover::after { transform: scaleX(1); }\n.home-navbar .home-nav-link-active a { color: #111111; }\n.home-navbar .home-nav-link-active::after { transform: scaleX(1); }\n\n.home-navbar .home-nav-menu svg {\n  color: #111111;\n  filter: none;\n  transition: color .25s ease;\n}\n\n.home-navbar #basic-button img { filter: brightness(0); }\n\n.home-navbar .hero-shell {\n  position: relative;\n  width: min(100%, 1500px);\n  aspect-ratio: 1440 / 671;\n  margin-inline: auto;\n  overflow: hidden;\n  background: #05090d;\n}\n\n.home-navbar .hero-content-container {\n  position: relative;\n  z-index: 1;\n  height: 100%;\n}\n\n.home-navbar .hero-layout {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: minmax(0, 560px) minmax(0, 1fr);\n  align-items: center;\n  box-sizing: border-box;\n}\n\n.home-navbar .hero-copy {\n  width: 100%;\n  max-width: 560px;\n  padding-left: 0;\n  align-items: flex-start;\n  box-sizing: border-box;\n  position: relative;\n  z-index: 2;\n}\n\n.home-navbar .hero-copy::before {\n  content: \"\";\n  display: block;\n  width: 48px;\n  height: 1px;\n  margin-bottom: 18px;\n  background: #b88a44;\n}\n\n.home-navbar .hero-headline.MuiTypography-root {\n  max-width: 560px;\n  margin: 0;\n  color: #f4f1ea;\n  font-family: \"Cormorant Garamond\", serif;\n  font-size: 58px;\n  font-weight: 300;\n  line-height: .98;\n  letter-spacing: .01em;\n  text-transform: uppercase;\n}\n\n.home-navbar .hero-subtitle.MuiTypography-root {\n  margin: 16px 0 0;\n  color: #b88a44;\n  font-family: \"Cormorant Garamond\", serif;\n  font-size: 20px;\n  font-style: italic;\n  font-weight: 300;\n  line-height: 1.2;\n  letter-spacing: .01em;\n}\n\n.home-navbar .hero-service.MuiTypography-root {\n  max-width: 500px;\n  margin: 12px 0 0;\n  color: rgba(95, 107, 115, .9);\n  font-family: \"Poppins\", sans-serif;\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: .11em;\n  text-transform: uppercase;\n}\n\n.home-navbar .hero-actions {\n  width: auto;\n  margin-top: 28px;\n  align-self: flex-start;\n  display: flex;\n  flex: 0 0 auto;\n  justify-content: flex-start;\n}\n\n.home-navbar .signup-button.MuiButton-root {\n  width: 158px;\n  min-width: 0;\n  height: 44px;\n  padding: 0 18px;\n  border: 1px solid #b88a44;\n  border-radius: 3px;\n  background: #b88a44;\n  color: #10202b;\n  box-shadow: none;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1;\n  letter-spacing: .12em;\n  text-transform: uppercase;\n  transition: background-color .225s ease, border-color .225s ease, transform .225s ease;\n}\n\n.home-navbar .signup-button.MuiButton-root:hover {\n  border-color: #111111;\n  background: #111111;\n  color: #f7f5f0;\n  box-shadow: none;\n  transform: translateY(-1px);\n}\n\n.home-navbar .hero-media {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  display: flex;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.home-navbar .hero-watch {\n  display: block;\n  width: 100%;\n  height: 100%;\n  max-width: 1500px;\n  object-fit: cover;\n  object-position: center right;\n  border: 0;\n  margin: 0;\n}\n.home-navbar .home-nav-login.MuiButton-root {\n  width: 128px;\n  min-width: 128px;\n  height: 42px;\n  padding: 0 16px;\n  border: 1px solid #111111;\n  border-radius: 4px;\n  background: transparent;\n  color: #111111;\n  box-shadow: none;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 1;\n  letter-spacing: .12em;\n  text-transform: uppercase;\n  transition: background-color .225s ease, border-color .225s ease, color .225s ease;\n}\n\n.home-navbar .home-nav-login.MuiButton-root:hover {\n  border-color: #111111;\n  background: #111111;\n  color: #f7f5f0;\n  box-shadow: none;\n}\n\n.home-navbar .home-nav-avatar {\n  width: 36px;\n  height: 36px;\n  border: 1px solid rgba(184, 138, 68, .36) !important;\n  border-radius: 50%;\n  object-fit: cover;\n  cursor: pointer;\n}\n\n@media (max-width: 1100px) {\n  .home-navbar .home-nav-container,\n  .home-navbar .hero-content-container { padding-inline: 32px; }\n\n  .home-navbar .hero-watch { max-width: none; }\n  .home-navbar .home-nav-menu {\n    grid-template-columns: 1fr auto 1fr;\n    column-gap: 0;\n  }\n  .home-navbar .home-nav-center { gap: 40px; }\n  .home-navbar .home-nav-actions { gap: 32px; }\n  .home-navbar .home-nav-link a { font-size: 14px; }\n  .home-navbar .hero-copy { max-width: 480px; }\n  .home-navbar .hero-headline.MuiTypography-root { font-size: clamp(48px, 5.5vw, 60px); }\n  .home-navbar .hero-subtitle.MuiTypography-root { font-size: 19px; }\n  .home-navbar .hero-watch { object-position: 68% center; }\n}\n\n@media (max-width: 760px) {\n  .home-navbar .home-nav-container,\n  .home-navbar .hero-content-container { padding-inline: 16px; }\n  .home-navbar .home-nav-menu {\n    height: 64px;\n    min-height: 64px;\n    grid-template-columns: auto 1fr auto;\n  }\n  .home-navbar .home-nav-logo { width: 82px; }\n  .home-navbar .home-nav-center { gap: 12px; }\n  .home-navbar .home-nav-actions { gap: 12px; }\n  .home-navbar .home-nav-link { display: none; }\n\n  .home-navbar .hero-copy {\n    max-width: 360px;\n    padding-left: 0;\n  }\n  .home-navbar .hero-headline.MuiTypography-root { font-size: clamp(40px, 11vw, 52px); }\n\n  .home-navbar .hero-watch { width: 100%; object-position: 64% center; }\n  .home-navbar .signup-button.MuiButton-root { width: 158px; height: 44px; }\n}\n/* OTHER NAVBAR */\n.other-navbar {\n  width: 100%;\n  height: 300px;\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(rgba(14,17,22,0.93), rgba(14,17,22,0.99)),\n              url(\"/img/banner1.jpg\");\n  background-size: cover;\n  background-position: center;\n}\n\n.other-navbar .menu {\n  width: 100%;\n  height: 64px;\n  padding: 0 64px;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  border-bottom: 1px solid rgba(227, 192, 141, 0.07);\n  \n}\n\n.other-navbar .links {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 48px;\n  margin-right: 40px;\n}\n\n.other-navbar .hover-line a {\n  color: rgba(255,255,255,0.6) !important;\n  font-size: 10px !important;\n  text-transform: uppercase !important;\n  letter-spacing: 3px !important;\n  font-family: \"Poppins\", sans-serif !important;\n  font-weight: 400 !important;\n  text-decoration: none !important;\n  transition: color 0.3s ease;\n}\n\n.other-navbar .hover-line a:hover { color: #e3c08d !important; }\n\n.other-navbar .hover-line::after {\n  display: block; content: \"\";\n  border-bottom: 1px solid rgba(227,192,141,0.6);\n  transform: scaleX(0);\n  transition: transform 280ms ease-in-out;\n  margin-top: 4px;\n}\n\n.other-navbar .hover-line:hover::after { transform: scaleX(1); }\n\n.other-navbar .login-button {\n  background: transparent !important;\n  color: #e3c08d !important;\n  border: 1px solid rgba(227,192,141,0.55) !important;\n  border-radius: 0 !important;\n  padding: 9px 26px !important;\n  font-family: \"Poppins\", sans-serif !important;\n  font-size: 9px !important;\n  font-weight: 400 !important;\n  text-transform: uppercase !important;\n  letter-spacing: 3px !important;\n  cursor: pointer;\n  transition: all 0.3s ease !important;\n}\n\n.other-navbar .login-button:hover {\n  background: #e3c08d !important;\n  color: #0e1116 !important;\n}\n \n.other-navbar.products-navbar {\n  width: 100%;\n  height: 78px;\n  min-height: 78px;\n  background: #f7f5f0;\n  border-bottom: 1px solid rgba(17, 17, 17, .08);\n}\n\n.other-navbar.products-navbar .navbar-container {\n  width: 100%;\n  max-width: 1500px;\n  height: 100%;\n  max-width: 1500px;\n  margin: 0 auto;\n  padding: 0 64px;\n  box-sizing: border-box;\n}\n\n.other-navbar.products-navbar .menu {\n  width: 100%;\n  height: 78px;\n  min-height: 78px;\n  padding: 0;\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  column-gap: 0;\n  align-items: center;\n  border-bottom: 0;\n  box-sizing: border-box;\n}\n\n.other-navbar.products-navbar .other-nav-brand {\n  display: flex;\n  align-items: center;\n  justify-self: start;\n}\n\n.other-navbar.products-navbar .brand-logo {\n  display: block;\n  width: 98px;\n  height: auto;\n  object-fit: contain;\n  filter: brightness(0);\n}\n\n.other-navbar.products-navbar .other-nav-center {\n  width: auto;\n  margin: 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  justify-self: center;\n  flex-wrap: nowrap;\n  gap: 56px;\n  white-space: nowrap;\n}\n\n.other-navbar.products-navbar .other-nav-actions {\n  margin: 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  justify-self: end;\n  gap: 46px;\n  white-space: nowrap;\n}\n\n.other-navbar.products-navbar .other-nav-center > :not(style) ~ :not(style),\n.other-navbar.products-navbar .other-nav-actions > :not(style) ~ :not(style) {\n  margin: 0;\n}\n\n.other-navbar.products-navbar #basic-button img { filter: brightness(0); }\n\n.other-navbar.products-navbar .hover-line a {\n  color: #111111 !important;\n  font-family: \"Poppins\", sans-serif !important;\n  font-size: 14px !important;\n  font-weight: 400 !important;\n  line-height: 1.5;\n  letter-spacing: .12em !important;\n}\n\n.other-navbar.products-navbar .hover-line a.underline {\n  color: #111111 !important;\n  border-bottom: 1px solid #b88a44;\n}\n\n.other-navbar.products-navbar .login-button {\n  width: 128px;\n  min-width: 128px;\n  height: 42px;\n  padding: 0 16px !important;\n  border: 1px solid #111111 !important;\n  border-radius: 4px !important;\n  background: transparent !important;\n  color: #111111 !important;\n  box-shadow: none;\n  font-family: \"Poppins\", sans-serif !important;\n  font-size: 11px !important;\n  font-weight: 500 !important;\n  line-height: 1;\n  letter-spacing: .12em !important;\n}\n\n.other-navbar.products-navbar .login-button:hover {\n  border-color: #111111 !important;\n  background: #111111 !important;\n  color: #f7f5f0 !important;\n  box-shadow: none;\n}\n\n.other-navbar.products-navbar .user-avatar {\n  width: 36px;\n  height: 36px;\n  border: 1px solid rgba(184, 138, 68, .36) !important;\n  border-radius: 50%;\n  object-fit: cover;\n  cursor: pointer;\n}\n\n@media (max-width: 1100px) {\n  .other-navbar.products-navbar .navbar-container { padding: 0 32px; }\n  .other-navbar.products-navbar .other-nav-center { gap: 40px; }\n  .other-navbar.products-navbar .other-nav-actions { gap: 32px; }\n}\n\n@media (max-width: 760px) {\n  .other-navbar.products-navbar .navbar-container { padding: 0 16px; }\n\n  .other-navbar.products-navbar .menu {\n    grid-template-columns: 1fr auto;\n  }\n\n  .other-navbar.products-navbar .brand-logo { width: 82px; }\n  .other-navbar.products-navbar .other-nav-center { display: none; }\n  .other-navbar.products-navbar .other-nav-actions { gap: 12px; }\n}/* BASKET ^5.8.4*/\n\n.basket-frame {\n  position: relative;\n  padding: 10px 4px 0px 4px;\n  width: 450px;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  background: #f8f8ff;\n  border-radius: 16px;\n}\n\n.basket-frame .all-check-box {\n  padding: 0px 6px;\n  width: 100%;\n  height: 34px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  background: #d7b586;\n  border-width: 1px 0px;\n  border-style: solid;\n  border-color: #343434;\n}\n\n.basket-frame .basket-info-box {\n  position: relative;\n  margin-top: 6px;\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.basket-info-box .product-img {\n  width: 60px;\n  height: 60px;\n  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25));\n  border-radius: 29px;\n}\n\n.basket-info-box .product-name {\n  margin-left: 11px;\n  width: 185px;\n  font-family: \"Poppins\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 30px;\n  color: #000000;\n}\n\n.basket-info-box .product-price {\n  width: 80px;\n  font-family: \"Poppins\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 22px;\n  color: #ae0000;\n}\n\n.basket-info-box\n  .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {\n  padding: 6.5px 14px;\n}\n\n.basket-info-box .css-ece9u5 {\n  min-width: 72px;\n}\n\n.basket-frame .cancel-btn {\n  position: absolute;\n  top: 33%;\n  right: 2%;\n  cursor: pointer;\n}\n\n.basket-frame .basket-order {\n  margin-top: 10px;\n  width: 100%;\n  height: 64px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-evenly;\n  align-items: center;\n  border-top: 1px solid rgba(0, 0, 0, 0.5);\n}\n\n.basket-order .price {\n  width: 200px;\n  display: flex;\n  font-family: \"Poppins\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 30px;\n  color: #000000;\n}\n\n.basket-frame .orders-wrapper {\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n  max-width: 1500px;\n  display: flex;\n  flex-direction: column;\n  overflow-y: scroll;\n}\n\n.basket-frame .orders-wrapper::-webkit-scrollbar {\n  width: 10px;\n}\n\n.basket-frame .orders-wrapper::-webkit-scrollbar-thumb {\n  background-color: #888;\n  border-radius: 5px;\n}\n\n.basket-frame .orders-wrapper::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.basket-frame .orders-main-wrapper {\n  position: relative;\n  overflow: hidden;\n  margin-top: 10px;\n  width: 100%;\n  height: 260px;\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
